import { NotFoundError } from '@/features/shared/utils/setPageProps'
import { RouteName } from '@shared/constants/routes'
import { createServerSidePropsHandler } from '@/features/shared/serverUtils/ssrHelpers/createServerSidePropsHandler'
import { getProductSSRProps } from '@/features/shared/serverUtils/ssrHelpers/getProductSSRProps'
import { PDPComponent } from '@/features/shop/components/ProductDetail/ProductDetailPage'
import { withoutHeaderLayout } from '@/features/shared/components/Headers/Layouts/withoutHeaderLayout'
import { subscriptionPlansGuestQueryOptions } from '@/features/account/services/SubscriptionAux/queries'
import { noop } from '@/features/shared/utils/noop'

export const getServerSideProps = createServerSidePropsHandler(RouteName.PRODUCT, async (props) => {
  const {
    ssrContext,
    contextualRedirect,
    authContext: { isAuthenticated },
  } = props
  const { slug } = ssrContext.query
  const [, product_id = ''] = slug ?? []

  const productId = Number(product_id)

  if (!product_id || isNaN(productId)) {
    if (contextualRedirect) return contextualRedirect
    throw new NotFoundError(`Invalid product id: "${productId}"`)
  }
  const [productProps] = await Promise.all([
    getProductSSRProps(props, productId),
    !isAuthenticated
      ? props.queryClient.query(subscriptionPlansGuestQueryOptions).catch(noop)
      : undefined,
  ])

  if ('redirect' in productProps) return productProps

  return {
    props: {
      productId,
    },
  }
})

// due to the weirdness of routing for PDP, we have to suppress the footer both for this route and the shop/products/:id route, and have the NewFooter rendered within the PDP components.
export default withoutHeaderLayout(PDPComponent, { suppressFooter: true })
